import styled from "styled-components"

const OrangeBox = styled.div`
    border: solid 4px rgb(255, 123, 0);
    padding: 5px;
    margin: 10px;
    width: 700px;
    `

const OrangeH1 = styled.h1`
    color: white;
    background-color: rgb(255, 123, 0);
`

const GoldBox = styled.div`
border: solid 4px rgb(0,139,139);
padding: 5px;
margin: 10px;
`

const GoldH1 = styled.h1`
    color: white;
    background-color: rgb(0,139,139);
`


const GreenBox = styled.div`
border: solid 4px rgb(85, 200, 85);
padding: 5px;
margin: 10px;
width: 500px;
`

const GreenH1 = styled.h1`
    color: white;
    background-color: rgb(85, 200, 85);
`

const YellowBox = styled.div`
    border: solid 4px rgba(231, 247, 108, 1);
    padding: 5px;
    margin: 10px;
`

const YellowH1 = styled.h1`
    color: white;
    background-color: rgba(231, 247, 108, 1);
`

export { OrangeBox, OrangeH1, GoldBox, GoldH1, GreenBox, GreenH1, YellowBox, YellowH1 }